<template>
    <div class="section">
        <a name="introduction"></a>
        <div id="introduction" class="container">
            <div class="md-layout">
                <div class="md-layout-item md-medium-size-66 md-small-size-100 mx-auto">
                    <center><h1 class="text-center">Как это работает?</h1></center>
                    <h4 class="description text-center">
                        Несколько мобильных приложений интегрируются с вашей 1С. Сотрудники и клиенты  всегда имеют актуальную информацию, возможность создать документ и мгновенно отправить в офис. Супервайзеры получают приложение для контроля сотрудников.
                    </h4>
                </div>
            </div>
            <div class="md-layout-item md-layout md-gutter">
                <div class="md-layout-item">
                    <rotating-card
                            card-bg="warning"
                            :manual-rotate-state="manualRotateState1"
                            manual-rotate>
                        <template slot="frontRotateCardContent">
                            <h5 class="card-category card-category-social">
                                <i class="fas fa-mobile-alt"></i> Мобильное приложение
                            </h5>
                            <h4 class="card-title">
                                <a
                                        href="javascript:void(0)"
                                >Для торговых представителей и мерчендайзеров
                                </a>
                            </h4>
                            <p class="card-description">
                                Мобильное приложение содержит актуальный каталог товаров, позволяет создать заказ, возврат внести оплату, фотоотчет, заполнить анкету, напечатать чек в соответствии с ФЗ-54. Контроль передвижения сотрудника по GPS ...
                            </p>
                            <br>
                            <div class="stats text-center">
                                <md-button
                                        href="javascript:void(0)"
                                        class="md-white md-round"
                                        @click="manualRotateState1 = true"
                                >
                                    подробнее...
                                </md-button>
                            </div>
                        </template>
                        <template slot="backRotateCardContent">
                            <h5 class="card-title">
                                AkiTorg мобильная торговля
                            </h5>
                            <p class="card-description">
                                Вы можете протестировать бесплатно весь функционал приложения на неограниченном количестве устройств. Или попробовать приложение прямо сейчас в демо-режиме.
                            </p>

                            <div class="stats text-center">

                                <md-button href="https://play.google.com/store/apps/details?id=com.akitorg.agent20" target="_blank" class="md-white md-round md-white">
                                    <i class="fab fa-google-play"></i>
                                </md-button>

                                <md-button href="https://apps.apple.com/ru/app/akitorg-%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D1%8C%D0%BD%D0%B0%D1%8F-%D1%82%D0%BE%D1%80%D0%B3%D0%BE%D0%B2%D0%BB%D1%8F/id1420503935" target="_blank" class="md-white md-round md-white">
                                    <i class="fab fa-app-store-ios"></i>
                                </md-button>
                                <md-button href="#connect" class="md-success md-round md-white">
                                    протестировать бесплатно
                                </md-button>
                                <br>
                                <br>
                                <md-button
                                        href="javascript:void(0)"
                                        class="md-white md-round"
                                        @click="manualRotateState1 = false">
                                    <md-icon class="md-icon-button">
                                        refresh
                                    </md-icon>
                                </md-button>
                            </div>
                        </template>
                    </rotating-card>
                </div>
                <div class="md-layout-item">
                    <rotating-card
                    card-bg="info"
                    :manual-rotate-state="manualRotateState2"
                    manual-rotate>
                <template slot="frontRotateCardContent">
                    <h5 class="card-category card-category-social">
                        <i class="fas fa-mobile-alt"></i> Мобильное приложение
                    </h5>
                    <h4 class="card-title">
                        <a
                                href="javascript:void(0)"
                        >Для ваших клиентов
                        </a>
                    </h4>
                    <p class="card-description">
                        Это электронный каталог с фото товаров, в котором клиент может сам сформировать заказ и отправить торговому представителю в приложение "Мобильная торговля". Цены и ассортимент для каждого пользователя  могут устанавливаться индивидуально.
                    </p>
                    <br>
                    <br>
                    <div class="stats text-center">
                        <md-button
                                href="javascript:void(0)"
                                class="md-white md-round"
                                @click="manualRotateState2 = true"
                        >
                            подробнее...
                        </md-button>
                    </div>
                </template>
                <template slot="backRotateCardContent">
                    <h5 class="card-title">
                        AkiTorg Заказ
                    </h5>
                    <p class="card-description">
                        Приложение распространяется бесплатно. Вы можете протестировать весь функционал приложения на неограниченном количестве устройств. Или попробовать приложение  прямо сейчас в демо-режиме.
                    </p>
                    <div class="stats text-center">
                        <md-button href="https://play.google.com/store/apps/details?id=com.akitorg.provider" target="_blank" class="md-white md-round md-white">
                            <i class="fab fa-google-play"></i>
                        </md-button>

                        <md-button href="https://apps.apple.com/us/app/akitorg-%D0%B7%D0%B0%D0%BA%D0%B0%D0%B7/id1482629784?l=ru#?platform=iphone" target="_blank" class="md-white md-round md-white">
                            <i class="fab fa-app-store-ios"></i>
                        </md-button>
                        <md-button href="#connect" class="md-success md-round md-white">
                            протестировать бесплатно
                        </md-button>
                        <md-button
                                href="javascript:void(0)"
                                class="md-white md-round"
                                @click="manualRotateState2 = false">
                            <md-icon class="md-icon-button">
                                refresh
                            </md-icon>
                        </md-button>
                    </div>
                </template>
            </rotating-card>
                </div>
                <div class="md-layout-item">
                    <rotating-card
                            card-bg="success"
                            :manual-rotate-state="manualRotateState3"
                            manual-rotate>
                        <template slot="frontRotateCardContent">
                            <h5 class="card-category card-category-social">
                                <i class="fas fa-mobile-alt"></i> Мобильное приложение
                            </h5>
                            <h4 class="card-title">
                                <a
                                        href="javascript:void(0)">
                                    Для Супервайзеров
                                </a>
                            </h4>
                            <p class="card-description">
                                В режиме реального времени позволяет контролировать работу и передвижения торговых представителей. Просматривать заказы, количество собранных денег и маршруты передвижения торговых представителей.
                            </p>
                            <br>
                            <br>
                            <br>
                            <div class="stats text-center">
                                <md-button
                                        href="javascript:void(0)"
                                        class="md-white md-round"
                                        @click="manualRotateState3 = true"
                                >
                                    подробнее...
                                </md-button>
                            </div>
                        </template>
                        <template slot="backRotateCardContent">
                            <h5 class="card-title">
                                AkiTorg Супервайзер
                            </h5>
                            <p class="card-description">
                                Приложение работает на Android и iOS. Вы можете протестировать бесплатно весь функционал приложения, или попробовать приложение прямо сейчас в демо-режиме.
                            </p>
                            <div class="stats text-center">
                                <md-button href="https://play.google.com/store/apps/details?id=com.akitorg.monitor" target="_blank" class="md-white md-round md-white">
                                    <i class="fab fa-google-play"></i>
                                </md-button>

                                <md-button href="https://apps.apple.com/ru/app/akitorg-%D1%81%D1%83%D0%BF%D0%B5%D1%80%D0%B2%D0%B0%D0%B9%D0%B7%D0%B5%D1%80/id904764265#?platform=iphone" target="_blank" class="md-white md-round md-white">
                                    <i class="fab fa-app-store-ios"></i>
                                </md-button>
                                <md-button href="#connect" class="md-warning md-round md-white">
                                    протестировать бесплатно
                                </md-button>
                                <md-button
                                        href="javascript:void(0)"
                                        class="md-white md-round"
                                        @click="manualRotateState3 = false">
                                    <md-icon class="md-icon-button">
                                        refresh
                                    </md-icon>
                                </md-button>
                            </div>
                        </template>
                    </rotating-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { InfoAreas } from "@/components";
  import RotatingCard from "../cards/RotatingCard";

  export default {
    name: "Introduction",
    components: {
      RotatingCard
      // InfoAreas
    },
    data() {
      return {
        manualRotateState1: false,
        manualRotateState2: false,
        manualRotateState3: false,
      };
    }
  };
</script>

<style lang="css"></style>
